import {
  CalendarOutlined,
  HourglassOutlined,
  VideoCameraOutlined,
  PhoneOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import {Space, Divider} from "antd";
import {TCustomerPaidBundleApiResponse} from "../../../../../../../react-query-hooks/customer";
import {capitalizeFirstLetter} from "../../../../../../../services/helpers";
import {
  StyledModalContentWrapper,
  StyledCallCardExtraInfo,
  StyledModalContentInfo,
} from "../../../../call-card/call-card.style";

/**
 * The offering's booking questions arrive as a raw JSON string, and a malformed
 * one must not take the modal down with it.
 */
const parseBookingQuestions = (
  raw: string | null | undefined
): {question: string; answer: string}[] => {
  if (!raw) {
    return [];
  }
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const PaidBundlesDetailsModal = ({call}: {call: TCustomerPaidBundleApiResponse}) => {
  if (!call.service) {
    return null;
  }
  const bookingQuestions = parseBookingQuestions(call.service.bookingQuestions);
  return (
    <>
      <StyledModalContentWrapper>
        <StyledCallCardExtraInfo className="call-card-extra-info">
          {/* <div className="call-card-extra-info-item">
                    <Space size={10}>
                      <DollarOutlined style={{color: "#222222"}} />
                      <span className="call-card-extra-info-item-value">₦5,000</span>
                    </Space>
                  </div> */}
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <CalendarOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">
                {call.bookedSessions} out of {call.noOfSessions} sessions
              </span>
            </Space>
          </div>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <DollarOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">
                {/* The currency sits on the bundle row, not on the service. */}
                {call.price === 0
                  ? "Free"
                  : `${call.currency ?? ""} ${call.price.toLocaleString("en-US")}`.trim()}
              </span>
            </Space>
          </div>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <HourglassOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">
                {call.service.callDuration} minutes
              </span>
            </Space>
          </div>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              {call.service.videoLocation ? (
                <>
                  <VideoCameraOutlined style={{color: "#222222"}} />
                  <span className="call-card-extra-info-item-value">Video call</span>
                </>
              ) : (
                <>
                  <PhoneOutlined style={{color: "#222222"}} />
                  <span className="call-card-extra-info-item-value">Phone call</span>
                </>
              )}
            </Space>
          </div>
        </StyledCallCardExtraInfo>
      </StyledModalContentWrapper>
      {bookingQuestions.map((question, idx) => (
        <div key={idx}>
          <StyledModalContentWrapper>
            <StyledModalContentInfo>
              {/* <h3 className="content-heading">Question</h3> */}
              <p className="content-text">
                <strong>Question:</strong> {capitalizeFirstLetter(question.question)}
              </p>
              {/* <p className="content-text">
                    <strong>Answer:</strong> {question.answer}
                  </p> */}
            </StyledModalContentInfo>
          </StyledModalContentWrapper>
          <Divider style={{margin: 0}} />
        </div>
      ))}
    </>
  );
};

export {PaidBundlesDetailsModal};
